import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtonsWithProgramme } from 'pages/custom/shared/detail/CompanyButtonsWithProgramme';
import { S_PageStyle } from 'pages/page/PageStyle';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const RevolvePage = (props: Props): JSX.Element => {
    return (
        <S_RevolvePage className={props.className}>
            <CustomMapPage
                mapId={'d2f3ccce-9815-4083-bde9-e8c9a2f865fe'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/7adb5e3c-ae84-4751-b173-7c4f83ed8fb9.png',
                    logoText: 'Revolvedagen',
                    logoSubtext: 'Interaktivt kart',
                    link: 'https://www.revolve.no/revolveday',
                    linkText: Localization.WEBSITE
                }}
                controls={
                    <CompanyButtonsWithProgramme
                        programmeTitle="Program i EL6"
                        programeId="487a7c15-0a09-473b-9b66-1a284d8b4039"
                    />
                }
            />
        </S_RevolvePage>
    );
};

const S_RevolvePage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
